// extracted by mini-css-extract-plugin
export default {"recaptcha":"sPPnrfzKTqLz5lX23r3f"};